module.exports = __webpack_public_path__ + "static/media/arrow-right-long-gray.6075e1c8.svg";